import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=50218390&scoped=true&"
import script from "./ScheduleItem.vue?vue&type=script&lang=js&"
export * from "./ScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=50218390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50218390",
  null
  
)

export default component.exports